import styles from './OutputSkeleton.module.css';

const Spinner = ({ size = 12, color = 'white' }) => {
    const strokeWidth=size/4;
    const radius=20;
    const viewBoxSize=50;

    return (
        <svg
          width={size}
          height={size}
          viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
          className={styles['spinner']}
        >
          <circle
            cx="25"
            cy="25"
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={Math.PI * radius * 0.2}
            strokeDashoffset="0"
          />
        </svg>
    );
};

export default function OutputSkeleton(){
    return(
        <div className={styles.resultBlock}>
            <div className={styles.inputEcho}>
                <Spinner/>
                <span>Running...</span>
            </div>
            <div className={styles.gridTable}>
                <div className={styles.gridHeader}>
                    <div>Model</div>
                    <div>Prediction</div>
                    <div>Score</div>
                    {/* <div>Detail</div> */}
                </div>
                <div className={styles.gridBody}>
                    {[...Array(3)].map((_,i)=><>
                        <div/>
                        <div className={styles.spam}/>
                        <div className={styles.scoreBar}/>
                    </>)}
                </div>
            </div>
        </div>
    )

}